<template>
  <div class="lottie-bg">
    <div id="lottie">
      <img src="@images/loading3.gif" rel="preload" />
    </div>
  </div>
</template>

<script>
import { auth, checkAuthState } from "@libs/wechat";

export default {
  name: "Loading",
  mounted() {
    const { code, state } = this.$route.query;
    console.info("Loading:", code, this.$route.query);
    if (!code || !checkAuthState(state)) {
      console.error(
        "微信授权校验失败：缺少 code 或 state 与发起授权时不一致",
        this.$route.query
      );
      this.$router.replace({ path: "/error" });
      return;
    }
    auth(code)
      .then(() => {
        // location.replace(
        //   decodeURIComponent(decodeURIComponent(this.$route.params.url))
        // );
        location.href = decodeURIComponent(
          decodeURIComponent(this.$route.params.url)
        );
      })
      .catch((res) => {
        console.error("微信授权出错，loading。。。。。", res);
        this.$router.replace({ path: "/error" });
      });
  },
};
</script>

<style scoped>
.lottie-bg {
  width: 100vw;
  height: 100vh;
}

#lottie {
  width: 100vw;
  height: 100vh;
  text-align: center;
  position: relative;
}
#lottie img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
</style>
